var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "lab_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 15,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.897 3a.986.986 0 00-.45 1.864V9.43c0 .296-.05.59-.15.868l-3.113 6.775-.006.017a2.951 2.951 0 002.773 3.96h8.502a2.951 2.951 0 002.773-3.96l-.006-.017-3.113-6.775c-.1-.279-.15-.572-.15-.868V4.864A.986.986 0 0015.507 3h-6.61zm1.522 6.43V4.972h3.566V9.43c0 .532.093 1.06.274 1.559l.007.017.59 1.283H9.547l.59-1.283.007-.018c.181-.499.274-1.026.274-1.558zm-3.394 8.35l1.617-3.518h7.12l1.616 3.518a.978.978 0 01-.925 1.298H7.95a.98.98 0 01-.926-1.298z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lab_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M-2.556-3.524h32.923v32.923H-2.556z"
  }))));
}
export default SvgLab;